export default "__VITE_ASSET__B63pZ7Rv__"